import { ICorrelation } from '@app/api/interfaces/correlation.interface';
import { ILoggerDeployment } from '@app/api/interfaces/logger-deployment-data.interface';
import { Dictionary } from '@ngrx/entity';

export function getSerialNoPairKey(serialNo1: string, serialNo2: string): string {
  return [serialNo1, serialNo2].sort().join('-');
}

export function getSerialNoPairMapToCorrelations(
  correlations: ICorrelation[],
  loggerDeploymentsMap: Dictionary<ILoggerDeployment>
): Record<string, string[]> {
  return correlations.reduce(
    (acc, correlation) => {
      const serialNo1 = loggerDeploymentsMap[correlation.logger1DeploymentId]?.serialNo;
      const serialNo2 = loggerDeploymentsMap[correlation.logger2DeploymentId]?.serialNo;

      if (!serialNo1 || !serialNo2) {
        return acc;
      }

      const pairKey = getSerialNoPairKey(serialNo1, serialNo2);
      if (!acc[pairKey]) {
        acc[pairKey] = [];
      }

      acc[pairKey] = [...new Set([...acc[pairKey], correlation.id])];

      return acc;
    },
    {} as Record<string, string[]>
  );
}
